import { useParams } from 'react-router-dom';
import { STORAGE_KEY } from '../../shared/config';
import { useTitle } from '../../shared/hooks/useTitle';
import { getJSONItem } from '../../shared/services/storage/storage';
import PageContainer from '../components/PageContainer';
import PageHeader from '../components/PageHeader';
import ThanksInstructions from '../components/ThanksInstructions';
import { isCarrierFieldEnabled } from '../utils/isFieldEnabled';
import { THANKS_KEY } from '../constants/baseRoutePaths';
import { pageSubtitles, pageTitles } from '../constants/fields';

const Thanks = () => {
  const state = getJSONItem(STORAGE_KEY.B2C_STATE, null);
  const isCarrierEnabled = isCarrierFieldEnabled(state);
  const { pdf } = useParams();

  const title = pageTitles[THANKS_KEY];
  const subtitle = typeof pageSubtitles[THANKS_KEY] !== 'string' && pageSubtitles[THANKS_KEY](isCarrierEnabled);

  useTitle(title);

  return (
    <PageContainer>
      <>
        <PageHeader title={title} subtitle={subtitle || ''} />
        <div>
          <ThanksInstructions isCarrierEnabled={isCarrierEnabled} pdf={pdf} />
        </div>
        <p>
          I tuoi risultati saranno pronti fra 2-3 settimane e nei prossimi giorni il nostro nutrizionista più vicino a
          te ti contatterà per fissare un appuntamento.
        </p>
        {/* <p>
          Nel frattempo potresti iniziare a registrare quello che mangi quotidianamente nella nostra app{' '}
          <a href="https://www.youmeals.it">Youmeals</a>, questo aiuterà il nutrizionista a conoscere le tue abitudini
          alimentari ed a creare un piano nutrizionale veramente su misura per te.
        </p> */}
        <p>Per qualunque dubbio siamo a tua disposizione.</p>
      </>
    </PageContainer>
  );
};

export default Thanks;
